import { Injectable } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import { right } from '@popperjs/core';
import { defaultColumn, DELETE_RECORD_LABEL, grid_widths_map } from '@piqet-angular/shared';
import { Subject } from 'rxjs';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';

@Injectable({
  providedIn: 'root',
})
export class ProjectSavingLogsDataGridService {
  projectSavingLogsPayload: any;
  event: any;

  constructor(private swalService: SwalService) {}

  deleteProjectSavingLogs = new Subject();
  deleteProjectSavingLogsData$ = this.deleteProjectSavingLogs.asObservable();

  getProjectSavingLogsDataColumn(): ColDef[] {
    const colDef: ColDef[] = [];
    colDef.push({
      ...defaultColumn,
      colId: 'projectName',
      headerName: 'Project name',
      field: 'projectName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'ecoPackageName',
      headerName: 'Eco-designed package',
      field: 'ecoPackageName',
      suppressColumnsToolPanel: true,
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'supersededPackageName',
      headerName: 'Superseded package',
      field: 'supersededPackageName',
      suppressColumnsToolPanel: true,
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'actions',
      headerName: 'Actions',
      field: 'actions',
      sortable: false,
      minWidth: grid_widths_map.sm_column_xxm,
      maxWidth: grid_widths_map.sm_column_xs,
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'actionRenderer',
      cellRendererParams: {
        showDelete: true,
        value: 'projectSavingLogs',
        deleteData: (data: any, customName: any) => {
          this.deleteConfirmation(data.projectId);
        },
      },
      lockVisible: true,
      lockPosition: right,
      resizable: false,
    });
    return colDef;
  }

  getProjectSavingLogsPayload(searchData: any, sortColumnState?: any, event?: any) {
    if (event) {
      this.event = event;
    }
    const currentPage = this.event?.goToPage
      ? this.event.goToPage
      : this.event?.next
      ? this.event.currentPage + 1
      : this.event?.prev
      ? this.event?.currentPage - 1
      : this.event?.gridApi?.paginationGetCurrentPage() + 1;
    const pageSize = this.event?.gridApi.paginationGetPageSize();
    const startCount = pageSize * (currentPage - 1);

    const columns = this.getProjectSavingLogsDataColumn()
      .map((item: any) => {
        return {
          searchable: true,
          name: item.colId,
          orderable: true,
          data: item.colId,
        };
      })
      .filter(value => value?.name != 'actions');

    return (this.projectSavingLogsPayload = {
      search: {
        columnNameList: [],
        value: searchData || '',
      },
      columns: columns,
      order: [
        {
          columnName: sortColumnState?.columnName || 'projectName',
          dir:
            sortColumnState?.dir[0].toUpperCase() + sortColumnState?.dir.substr(1).toLowerCase() ||
            'Desc',
        },
      ],
      start: startCount || 0,
      length: pageSize == Number(this.event?.totalRecord) ? Number('-1') : pageSize || 10,
      draw: currentPage || 1,
    });
  }

  deleteConfirmation(data: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.deleteProjectSavingLogs.next([data]);
      }
    });
  }
}
